// extracted by mini-css-extract-plugin
export default {"breadcrumb":"vi-z","breadcrumbItem":"wi-z"};